import React from 'react';
import UploadedImage from './UploadedImage';
import UploadedVideo from './UploadedVideo';

type Props = {
  type: 'image' | 'video';
  url: string;
  publicFile?: boolean;
  previewClassName?: string;
};

const UploadedItem: React.FC<Props> = ({ type, url, publicFile, previewClassName }) => {
  return type === 'image' ? (
    <UploadedImage url={url} publicFile={publicFile} className={previewClassName} />
  ) : type === 'video' ? (
    <UploadedVideo url={url} />
  ) : (
    <>Invalid upload.</>
  );
};

export default UploadedItem;
